"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlCount = exports.useIsFetchingUrls = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var minifiedActions_1 = __importDefault(require("../../../CreateUrlModal/helpers/minifiedActions"));
var isFiltered_1 = __importDefault(require("../../../EmptyState/isFiltered"));
var prevState_1 = __importDefault(require("../../../CreateUrlModal/helpers/prevState"));
function useIsFetchingUrls() {
    var isFetchingUrls = react_redux_1.useSelector(function (state) { return state.user.isFetchingUrls; });
    return isFetchingUrls;
}
exports.useIsFetchingUrls = useIsFetchingUrls;
function useUrlCount() {
    var urlCount = react_redux_1.useSelector(function (state) { return state.user.urlCount; });
    return urlCount;
}
exports.useUrlCount = useUrlCount;
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        linkCountHeader: (_a = {
                flexGrow: 1,
                flexShrink: 0,
                alignSelf: 'center',
                marginRight: 20,
                whiteSpace: 'nowrap'
            },
            _a[theme.breakpoints.down('sm')] = {
                order: 10,
                flexBasis: '100%',
                marginTop: theme.spacing(3),
            },
            _a),
    });
});
function LinkCountHeader() {
    var isFetchingUrls = useIsFetchingUrls();
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var urlCount = useUrlCount();
    var isMinified = minifiedActions_1.default();
    var isFiltered = isFiltered_1.default();
    var classes = useStyles();
    var nextDescriptor = !isFiltered ? t('text.links') : t('text.results');
    var prevState = prevState_1.default(nextDescriptor, !isFetchingUrls) || 'links';
    var currentDescriptor = !isFetchingUrls ? nextDescriptor : prevState;
    return (react_1.default.createElement(core_1.Typography, { className: classes.linkCountHeader, variant: isMinified ? 'h4' : 'h3', color: "primary" }, urlCount + " " + currentDescriptor));
}
exports.default = LinkCountHeader;
